<template>
  <div id="EN">
  	<home-header :navName="navName"></home-header>
  	<div id="bodyer">
  		EN
  	</div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import axios from 'axios'
import HomeHeader from './header'
import HomeFooter from './footer'
export default {
  name: 'facilityCloud',
  components:{
  	HomeHeader:HomeHeader,
    HomeFooter:HomeFooter
  },
  data: function() {
  		return {
  			listdata:"",
  			navName:"EN"
  		}
  },
  methods:{
  	getGcmsList:function(){

  	},
  	updateData:function(data){

  	}
  },
  mounted:function(){
  	this.getGcmsList();

  }
}
</script>
<style>
#bodyer{
  margin-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/EN.vue